import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enHome from "@/locales/en/home.json";
import enBooking from "@/locales/en/booking.json";
import enNgu from "@/locales/en/ngu.json";

import esHome from "@/locales/es/home.json";
import esBooking from "@/locales/es/booking.json";
import esNgu from "@/locales/es/ngu.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        home: enHome,
        booking: enBooking,
        ngu: enNgu,
      },
      es: {
        home: esHome,
        booking: esBooking,
        ngu: esNgu,
      },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "es"],
    ns: ["home", "booking", "ngu"],
    defaultNS: "home",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng",
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
  });

export default i18n;
